module.exports = __webpack_public_path__ + "img/my-account-desktop-ru.b00eb099.jpg";